// extracted by css-extract-rspack-plugin
export default {"Box":"repo-picker-module__Box__HHazab0","Text":"repo-picker-module__Text__Kg60yHL","Text_1":"repo-picker-module__Text_1__oyZMI9S"};